import React from 'react';

export function NotFound() {
  return <h3 style={{ textAlign: 'center' }}>Sorry! The resource you are looking for has not been found.</h3>;
}
